import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { DashboardService } from '../_services/dashboard.service';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import * as FILESAVER from 'file-saver';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-school-dimissal-flow-log',
  templateUrl: './school-dimissal-flow-log.component.html',
  styleUrls: ['./school-dimissal-flow-log.component.scss']
})
export class SchoolDimissalFlowLogComponent implements OnInit, OnDestroy {
  loading = true;
  reportFilter;
  readyToPickup;
  readyTillReceived;
  dismissalProcess;
  @Input() showHeader;
  @Input() activeTab;

  dismissalAverageTime: any = {};
  dismissalStatistics: any = {};
  sub: Subscription;
  printSub: Subscription;
  currLang;
  @Output() stopLoading = new EventEmitter();

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dashboardService: DashboardService) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.sub = new Subscription();
    this.printSub = new Subscription();
    // this.dashboardService.subScribeToChannel(`dashboardDismissalProcess_${localStorage.getItem('schoolId')}`, `App\\Events\\DashboardDismissalProcess`, (data) => {
    //   if (localStorage.getItem("date") == moment(new Date()).format('YYYY-MM-DD')) {
    //     this.updateDashboardDismissalProcessData(data);
    //   }
    // });

  }
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.printSub.unsubscribe();
  }

  ngOnInit(): void {
    let date = localStorage.getItem("date");
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.getDismissalReport(date ? date : moment(new Date()).format('YYYY-MM-DD'));
    let x = this.dashboardService.getReportFilter().subscribe((res: any) => {
      if (res !== null) {
        this.reportFilter = res;
        this.getDismissalReport(this.reportFilter.toDate);
      }
    })
    this.sub.add(x);

    let p = this.dashboardService.getDownloadData().subscribe((res: any) => {
      if (res && (this.router.url.split('/')[2] === 'dismissal-reports') && this.activeTab === 'home-tab') {
        let workBook = XLSX.utils.book_new();
        workBook.SheetNames.push('test sheet');
        let valuesToBeExported = [];
        valuesToBeExported.push(
          {
            'get ready to pickup': this.getTimeimMins(this.dismissalAverageTime.avg_yellow_zone),
            'pickup till recieved': this.getTimeimMins(this.dismissalAverageTime.avg_green_zone),
            'the dismissal process': this.getTimeimMins(this.dismissalAverageTime.avg_full_request)
          })

        valuesToBeExported.push(
          {
            'Request By Parent': (this.dismissalStatistics.parent_requests),
            'Request By Assistant': (this.dismissalStatistics.helper_requests),
            'Request By App': (this.dismissalStatistics.flow_pickup),
            'Request Via QR Code': (this.dismissalStatistics.qr_pickup),
            'Request By Bus': (this.dismissalStatistics.bus_pickup),
            'Request Regular': (this.dismissalStatistics.normal_pickup),
          })
        let ws_Data = valuesToBeExported;
        let ws = XLSX.utils.json_to_sheet(ws_Data);
        workBook.Sheets['test sheet'] = ws;
        let workBookOut = XLSX.writeFile(workBook, 'book.xlsx');

        function s2ab(s) {
          let buf = new ArrayBuffer(s.length);
          let view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF
          return buf;
        }
        $("#button-a").click(function () {
          FILESAVER.saveAs(new Blob([s2ab(workBookOut)], { type: "application/octet-stream" }), 'test.xlsx');
        });

      }

    })
    this.printSub.add(p);
  }

  getDismissalReport(date) {
    this.dashboardService.getDismissalAverageReport(date).subscribe((res: any) => {
      Object.keys(res).map(key => {
        this.dismissalAverageTime[key] = res[key];
      })
      this.dashboardService.getDismissalStatisticsReport(date).subscribe((res: any) => {
        Object.keys(res).map(key => {
          this.dismissalStatistics[key] = res[key];
        })
        this.stopLoading.emit();
        this.loading = false;
      })
    })
  }
  updateDashboardDismissalProcessData(data) {
    this.dismissalAverageTime = this.dismissalStatistics = data;
  }
  getTimeimMins(timeInSec) {
    return Math.floor(timeInSec / 60)
  }

  openDismissalReprots() {
    this.dashboardService.setDownloadData(false);
    this.router.navigateByUrl('/reports/dismissal-reports')
  }

}
